export default __webpack_public_path__ + "static/london-skyline-abe13f0262e6b9c9f9d609e7cdac236a.png";